var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"textIntro"},[_c('span',{staticClass:"is-h2 mr-2"},[_c('strong',[_vm._v("WELCOME | "+_vm._s(_vm.showFirstNameAndRole)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }